module.exports = __webpack_public_path__ + "static/media/af-lab_header_dots_02.5ca5ed61.mp4";